import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";

export class memberAddTraveller {
    private travellerForm:any   = $('#member-myadd-traveller');
    $scope: any = $('#member-myadd-traveller');
	$scope_gov: any = $('#members-travel--subsidy');
	private addForm:any   = $('#member-profile-add');
	$scopeoverlay: any = $('#myModalTraveller');
    private memberBase:any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	$instance:any;
	checkCnt:any = 1;
	initSelectizeInputs(): any {
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.travellerForm.find('select'));
		//_self.memberBase.initSelectizeInputs(inputSelectArr);
		
    }
	initTextInputs():any {
		let _self = this;
		let toDisableInputs:any = _self.travellerForm.find('.add-traveller-Airline-code input');
				toDisableInputs.each((i:number, el:any) => {
					$(el).prop({
						'disabled': 'true'
					});
					$(el).prev().css({	
						'background-color': '#eee',
						'border-top-left-radius':'10px',
						'border-top-right-radius': '10px'
					});
				});	
		
			let lastnameInputs = _self.travellerForm.find('.edit-profile--first-name input');
			lastnameInputs.attr({
				'data-parsley-pattern': '^[a-z A-Z]+$',
				'maxlength': '25'
			});

			let firstnameInputs = _self.travellerForm.find('.edit-profile--last-name input');
			firstnameInputs.attr({
				'data-parsley-pattern': '^[a-z A-Z]+$',
				'maxlength': '40',
				'minlength': '2'
			});
			let airlinenoInputs = _self.travellerForm.find('.add-traveller-airline-number input');
			airlinenoInputs.attr({
				'data-parsley-type': 'number',
				'maxlength': '20'
			});		
			let passsportno = _self.travellerForm.find('.add-passport--number input');
			passsportno.attr({
				'data-parsley-pattern': '^[a-zA-Z0-9]+$'
			});	
	}

	mytraveller(): any {
		let _self = this;
		 _self.$scope.find('.show-traveller-details').click((evt: any) => {
            let hideTraveller:any;
            let showTraveller:any;
            showTraveller = evt.currentTarget.previousSibling.id;
            $('#'+showTraveller).show();
            $(window).unbind('scroll');
            evt.preventDefault();
			if (($('#members-travel--subsidy').length)==0)
			{
				let gst_traveller=evt.currentTarget.previousSibling.children[1];
				$(gst_traveller).hide()
			}
            $('#'+evt.target.id).hide();
            hideTraveller =  evt.currentTarget.previousSibling.children[5].children[1].id;
            $('#'+hideTraveller).show();
           });

		   _self.$scope.find('.hide-traveller-details').click((evt: any) => {
            let hideTraveller:any;
            let showTraveller:any;
            showTraveller = evt.currentTarget.parentElement.parentElement.id;
            $('#'+showTraveller).hide();
            $(window).unbind('scroll');
            evt.preventDefault();
            evt.stopPropagation();
            $('#'+evt.target.id).hide();
            hideTraveller = evt.currentTarget.parentElement.parentElement.nextSibling.id;
            $('#'+hideTraveller).show();
           });		
}

    editmytraveller(): any {
		let _self = this;
		_self.$scope.find('.edittraveller-details').click((evt: any) => {
			$('.nric--IC--number--error').addClass("hideClass");
			$('.nric--IC--number--error').removeClass("showClass");
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
			$('.nric-files-upload').val('');
			$('.nric--upload--file--name').val('');
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
        let editTraveller:any;
		let disableallothers:any;
		let showeditform:any;
		editTraveller = evt.currentTarget.parentElement.className;
		 $("."+editTraveller).hide();
		 showeditform=evt.currentTarget.parentNode.parentElement.previousElementSibling.children[1].id;
		 $("#"+showeditform).show();
		let disableall=evt.currentTarget.parentElement.parentElement;
		 disableallothers=$(disableall).nextAll();
		let disableallothersqq=evt.currentTarget.parentNode.parentElement.previousElementSibling;
		let disableallothersq=$(disableallothersqq).prevUntil(".addmytraveller");
		$(disableallothers).css({ 'opacity': '0.5','pointer-events': 'none' });
		$(disableallothersq).css({ 'opacity': '0.5','pointer-events': 'none' });
		let indexedit=evt.currentTarget.parentNode.children[7].id;
		//indexedit = $('#'+indexedit).val();
		let i;
		if (($('#members-travel--subsidy').length) > 0) 
		{
			$('.edittraveller-details').css({ 'pointer-events': 'none' });
			$('.btn-memberadd--submit').css({ 'pointer-events': 'none' });
			$('.select--checkbox').css({'pointer-events': 'none' });	
			$('.check-box--terms--cond--section').css({ 'pointer-events': 'none' });
		}
		else
		{
			let circle_travel:any=evt.currentTarget.parentElement.children[1].children[2].children[0].children[0].innerText;
			$('.members-content-container .circle-travel').html(circle_travel);
		}
		 $(window).unbind('scroll');
		 evt.preventDefault();
         evt.stopPropagation();
		 let formData:Array<any> = [];
        let populateurl:string = '';
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/addtraveller.json';
		}
		else {
		populateurl = '/bin/services/new/getMytravellerAPI';
		}
		if(editTraveller=='firsttraveller_0')
		{
			let method = 'POST';
			if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/gst_traveller.json';
			method = 'GET';
			}
			else {
			populateurl = '/bin/services/new/updateuser';
			}
			var data = {
				'action': 'fetch'
			};
			$.ajax({
			type: method,
			data:data,
			url:populateurl,
			success: function(msg:any) {
				
				//_self.redirectUser(msg);
				if(msg != "{}")
				{

					let inputFields = {
						'title': 		 				editTraveller+'edit-profile--title',
						'firstName': 	 				editTraveller+'edit-profile--first-name',
						'lastName': 	 				editTraveller+'edit-profile--last-name',
						'birthDate': 	 				editTraveller+'edit-profile--date-of-birth',
						'passportnumber': 				editTraveller+'edit-profile--passport-number',
						'passportExpiryDate':   		editTraveller+'edit-profile--passport-expiry-date',
						'passportissuingcountry': 		editTraveller+'edit-traveller--passport-issue-country',
						'nationality': 		 			editTraveller+'edit-traveller--nationality',
						'airline': 						editTraveller+'edit-traveller--airline-name-selectized',
						'airlinecode': 					editTraveller+'edit-traveller--airline-codevalue',
						'airlinenumber':  				editTraveller+'edit-traveller--airline-number',
						'airlinecodehid':  				editTraveller+'edit-traveller--airline-code',
						'nric_number':  				editTraveller+'add-user--NRIC--number'
					}; 
					let res;			
					if(typeof msg==='string'){
						res = JSON.parse(msg);
						}else{
							res=msg;
						}
					let i;
					i= indexedit.split('x')[1]-2;
					let airlinecode=res.airlinecode
					   switch(airlinecode)
						{
						case 'AA' :
						$("#traveller-airline_"+i).html('American Airlines');
						var airlinename='American Airlines';
						break;
						case 'BA':
						var airlinename='British Airways';
						break;
						case 'KA' :
						var airlinename='Cathay Dragon';
						break;
						case 'CX' :
						var airlinename='Cathay Pacific';
						break;
						case 'EK' :
						var airlinename='Emirates';	
						break;
						case 'EY' :
						var airlinename='Etihad Airways';	
						break;
						case 'AY' :
						var airlinename='Finnair';
						break;
						case 'IB' :
						var airlinename='Iberia';
						break;
						case 'JL' :
						var airlinename='Japan Airlines';
						break;
						case 'KL' :
						var airlinename='KLM Royal Dutch Airlines';
						break;
						case 'LA' :
						var airlinename='LATAM Airlines Group';
						break;
						case 'MH' :
						var airlinename='Malaysia Airlines';
						break;
						case 'QF' :	
						var airlinename='Qantas Airways';	
						break;
						case 'QR' :	
						var airlinename='Qatar Airways';
						break;
						case 'RJ' :				
						var airlinename='Royal Jordanian';
						break;
						case 'S7' :						
						var airlinename='Siberia Airlines';
						break;
						case 'SQ' :						
						var airlinename='Singapore Airlines';
						break;
						case 'UL' :						
						var airlinename='SriLankan Airlines';
						break;		
						}
					var dobcont=res.dob;
					var date_ofbirth = new Date(dobcont);
					var expcont=res.expirydate;
					if(expcont != "")
					{
					var exp_date = new Date(expcont);
					}
 					let data = {

						'title': 						res.title,
						'firstName': 					res.firstName,
						'lastName': 					res.lastName,
						'birthDate': 					date_ofbirth,
						'passportnumber':				res.passportnumber,
						'passportExpiryDate':			exp_date,
						'passportissuingcountry':		res.passportissuingcountry,
						'nationality':					res.nationality,
						'airline':						airlinename,
						'airlinecode':					res.airlinecode,
						'airlinenumber':				res.airlinenumber,
						'airlinecodehid':  				res.airlinecode,
						'nric_number':  				res.nricnumber,
						'isused':  				        res.isused

					};
	
					$.each(inputFields, (param:any, inputId:any) => {
						// console.log(param, inputId, data[param]);
	
						let input:any = $('#'+inputId);
	
						// handle select inputs
						if (input.is('select')) 
						{
							input[0].selectize.setValue(data[param]);
						} else if (input.is('[type="checkbox"]')) {
						// handle checkbox inputs
							if (data[param]) {
								input.prop('checked', 'checked');
							}
						} else if (input.hasClass('datepicker')) {
							input.datepicker('setDate', data[param]);
							// handle date inputs
						} else {
							// handle all other inputs
							input.val(data[param]);
						}
	
						// handle group interests/festival inputs
						if (!input.length) {
							let inputGrp:any = $('[name="'+inputId+'"]');
							console.log(inputGrp.length, inputGrp);
	
							$.each(inputGrp, (i:number, inputEl:any) => {
								if ($.inArray(inputEl.value, data[param]) >= 0) {
									$(inputEl).prop('checked', 'checked');
								}
								$(inputEl)
							});
						}
	
						input.blur();
						// manually apply state to elements if not added by blur
						input.parent().find('label').addClass('input-filled');
						input.addClass('input-focused');
					});	
				}
				
			},
			error:function(msg:any){
				console.log(msg);
			}
		});
		}
		else
		{
		  $.ajax({
			type: 'GET',
			url:populateurl,
			success: function(msg:any) {
				
				//_self.redirectUser(msg);
				if(msg != "{}")
				{
					let inputFields = {
						'title': 		 				editTraveller+'edit-profile--title',
						'firstName': 	 				editTraveller+'edit-profile--first-name',
						'lastName': 	 				editTraveller+'edit-profile--last-name',
						'birthDate': 	 				editTraveller+'edit-profile--date-of-birth',
						'passportnumber': 				editTraveller+'edit-profile--passport-number',
						'passportExpiryDate':   		editTraveller+'edit-profile--passport-expiry-date',
						'passportissuingcountry': 		editTraveller+'edit-traveller--passport-issue-country',
						'nationality': 		 			editTraveller+'edit-traveller--nationality',
						'airline': 						editTraveller+'edit-traveller--airline-name-selectized',
						'airlinecode': 					editTraveller+'edit-traveller--airline-codevalue',
						'airlinenumber':  				editTraveller+'edit-traveller--airline-number',
						'airlinecodehid':  				editTraveller+'edit-traveller--airline-code',
						'nric':  				        editTraveller+'add-user--NRIC--number'
					}; 
					let res;			
					res =msg;
					let i;
					i= indexedit.split('x')[1]-3;
					let airlinecode=msg.travellersDetails[i].airlinecode
					   switch(airlinecode)
						{
						case 'AA' :
						$("#traveller-airline_"+i).html('American Airlines');
						var airlinename='American Airlines';
						break;
						case 'BA':
						var airlinename='British Airways';
						break;
						case 'KA' :
						var airlinename='Cathay Dragon';
						break;
						case 'CX' :
						var airlinename='Cathay Pacific';
						break;
						case 'EK' :
						var airlinename='Emirates';	
						break;
						case 'EY' :
						var airlinename='Etihad Airways';	
						break;
						case 'AY' :
						var airlinename='Finnair';
						break;
						case 'IB' :
						var airlinename='Iberia';
						break;
						case 'JL' :
						var airlinename='Japan Airlines';
						break;
						case 'KL' :
						var airlinename='KLM Royal Dutch Airlines';
						break;
						case 'LA' :
						var airlinename='LATAM Airlines Group';
						break;
						case 'MH' :
						var airlinename='Malaysia Airlines';
						break;
						case 'QF' :	
						var airlinename='Qantas Airways';	
						break;
						case 'QR' :	
						var airlinename='Qatar Airways';
						break;
						case 'RJ' :				
						var airlinename='Royal Jordanian';
						break;
						case 'S7' :						
						var airlinename='Siberia Airlines';
						break;
						case 'SQ' :						
						var airlinename='Singapore Airlines';
						break;
						case 'UL' :						
						var airlinename='SriLankan Airlines';
						break;		
						}
					var dobcont=res.travellersDetails[i].dob;
					var date_ofbirth = new Date(dobcont);
					var expcont=res.travellersDetails[i].expirydate;
					if(expcont != "")
					{
					var exp_date = new Date(expcont);
					}
 					let data = {

						'title': 						res.travellersDetails[i].title,
						'firstName': 					res.travellersDetails[i].givenName,
						'lastName': 					res.travellersDetails[i].lastname,
						'birthDate': 					date_ofbirth,
						'passportnumber':				res.travellersDetails[i].passportnumber,
						'passportExpiryDate':			exp_date,
						'passportissuingcountry':		res.travellersDetails[i].passportissuingcountry,
						'nationality':					res.travellersDetails[i].nationality,
						'airline':						airlinename,
						'airlinecode':					res.travellersDetails[i].airlinecode,
						'airlinenumber':				res.travellersDetails[i].airlinenumber,
						'airlinecodehid':  				res.travellersDetails[i].airlinecode,
						'nric':  				        res.travellersDetails[i].nric,
						'isused':  				        res.travellersDetails[i].isused

					};
	
					$.each(inputFields, (param:any, inputId:any) => {
						// console.log(param, inputId, data[param]);
	
						let input:any = $('#'+inputId);
	
						// handle select inputs
						if (input.is('select')) 
						{
							input[0].selectize.setValue(data[param]);
						} else if (input.is('[type="checkbox"]')) {
						// handle checkbox inputs
							if (data[param]) {
								input.prop('checked', 'checked');
							}
						} else if (input.hasClass('datepicker')) {
							input.datepicker('setDate', data[param]);
							// handle date inputs
						} else {
							// handle all other inputs
							input.val(data[param]);
						}
	
						// handle group interests/festival inputs
						if (!input.length) {
							let inputGrp:any = $('[name="'+inputId+'"]');
							console.log(inputGrp.length, inputGrp);
	
							$.each(inputGrp, (i:number, inputEl:any) => {
								if ($.inArray(inputEl.value, data[param]) >= 0) {
									$(inputEl).prop('checked', 'checked');
								}
								$(inputEl)
							});
						}
	
						input.blur();
						// manually apply state to elements if not added by blur
						input.parent().find('label').addClass('input-filled');
						input.addClass('input-focused');
					});	
				}
					
			},
			error:function(msg:any){
				console.log(msg);
			}
		});	  
		}
	});

}


	   cancelmytraveller(): any {
		let _self = this;
        _self.$scope.find('.cancelmytraveller-edit').click((evt: any) => {	
			$('.nric--IC--number--error').addClass("hideClass");
			$('.nric--IC--number--error').removeClass("showClass");
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
			$('.nric-files-upload').val('');
			$('.nric--upload--file--name').val('');
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
		$(".mytravellererror_message").html("");
		let cancelTraveller:any;
		let cancelmytravell:any;
		let cancel_showtravell:any;
		// let showeditform:any;
		cancelTraveller=evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
		cancelmytravell=cancelTraveller.children[1].id;
		let showhide=evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[3].children[5].children[1].id;
		$("#"+showhide).show();
		$("#"+cancelmytravell).hide();
		cancel_showtravell=cancelTraveller.nextElementSibling.children[0].className;
		$("."+cancel_showtravell).show();
		let cancel_showtra=cancelTraveller.nextElementSibling.children[0].children[3].id;
		$("#"+cancel_showtra).show();
		let cancel_showtrar=cancelTraveller.nextElementSibling.children[0].children[4].id;
		$("#"+cancel_showtrar).hide();
		let enableallothers_below=$(cancelTraveller).nextAll();	
		let enableallothers_above=$(cancelTraveller).prevAll();
		$(enableallothers_below).css({ 'opacity': '1','pointer-events': 'auto' });
		$(enableallothers_above).css({ 'opacity': '1','pointer-events': 'auto' });
		if (($('#members-travel--subsidy').length) > 0) {
			$('.check-box--terms--cond--section').css({ 'pointer-events': 'auto' });
			$('.btn-memberadd--submit').css({ 'pointer-events': 'auto' });
			$('.select--checkbox').css({'pointer-events': 'auto' });	
			for(let i=0;i<9;i++)
			{
				if($('.firsttraveller_'+i+' .edittraveller-details').hasClass("data-offer"))
				{
					$('.firsttraveller_'+i+' .edittraveller-details').css({ 'pointer-events': 'none' });
				}
				else{
					$('.firsttraveller_'+i+' .edittraveller-details').css({ 'pointer-events': 'auto' });
				}
			}
		}
      
		});
		 _self.$scope.find('#cancel-add-traveller').click((evt: any) => {
			$('.nric--IC--number--error').addClass("hideClass");
			$('.nric--IC--number--error').removeClass("showClass");
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
			$('.nric-files-upload').val('');
			$('.nric--upload--file--name').val('');
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
		$(".mytravellererror_message").html("");
        $('#addtraveller-detail').hide();
		$('.btn-memberadd--submit').show();
		$('#addtraveller_mobileadd').show();
		$('#addtraveller_mobileadd').show();
		let cancel_addtraveller:any;
		cancel_addtraveller=evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
		let addenableallothers_below=$(cancel_addtraveller).nextAll();
		$(addenableallothers_below).css({ 'opacity': '1','pointer-events': 'auto' });
		if (($('#members-travel--subsidy').length) > 0) {
			$('.check-box--terms--cond--section').css({ 'pointer-events': 'auto' });
			$('.btn-memberadd--submit').css({ 'pointer-events': 'auto' });
			$('.select--checkbox').css({'pointer-events': 'auto' });	
			for(let i=0;i<9;i++)
			{
				if($('.firsttraveller_'+i+' .edittraveller-details').hasClass("data-offer"))
				{
					$('.firsttraveller_'+i+' .edittraveller-details').css({ 'pointer-events': 'none' });
				}
				else{
					$('.firsttraveller_'+i+' .edittraveller-details').css({ 'pointer-events': 'auto' });
				}
			}
		}
		 $(window).unbind('scroll');
		 evt.preventDefault();
         evt.stopPropagation();
		});
	}
	deletemytraveller():any
	{
		let _self = this;
		_self.$scope.find('.deletetraveller-details').click((evt: any) => {
		let $deleteId:any = evt.target.parentNode.parentNode.parentNode.children[7].id;
		let $deletename:any = evt.target.parentNode.parentNode.parentNode.children[1].children[2].children[2].children[1].innerText;
		//$deleteId = $("#"+$deleteId).val();
		$("#deleteBox").val($deleteId);
		$('.removename').html($deletename+'<span style="color:#000;font-weight: 700">?</span>');
		 $(window).unbind('scroll');
		$.magnificPopup.open({
		items: {
			src: '#mytraveller-popup'
		},
		type:'inline',
		midClick: true,
		closeBtnInside: false
		});
		 evt.preventDefault();
         evt.stopPropagation();
		});

	}

	canceldeletemytraveller():any
	{
		let _self = this;
		_self.$scope.find('.btn-mytraveler--cancel').click((evt: any) => {
		$.magnificPopup.close()
		$(".mytravellererror_message").html("");
		 $(window).unbind('scroll');
		 evt.preventDefault();
         evt.stopPropagation();
		});
	}
	selectTraveller():any{
		let _self = this;

		_self.$scope.find('.check-box--section').click((evt: any) => {
			var targetId = evt.target.parentNode.firstElementChild.id;
			var indexArray1 = targetId.split('_');
			var indexArray2 = indexArray1[1].split("--");
			if (_self.$scope.find('#'+targetId). is(":checked") == true){

				$('.firsttraveller_'+indexArray2[0]).css('border','2px solid #46a049');
				let isTravellerSelected: any = false;
				if (($('#members-travel--subsidy').length) > 0) {
					$('#members-travel--subsidy input[type=checkbox]').each(function () {
						if (!$(this).hasClass('terms_check_gst')) {
							if ($(this).is(":checked") && $(this).parents().eq(5).children().eq(3).find('.traveller-colr').eq(1).text() == 'Adult')  {
								isTravellerSelected = true;
							}
						}

					});
				
				if ($('#gst--form--condition'). is(":checked") == true && isTravellerSelected){
					$('.gts-container').css({ 'opacity': '1','pointer-events': 'auto' });
				} else {
					$('.gts-container').css({ 'opacity': '0.5','pointer-events': 'none' });
				}
			}
			}else{
				let isTravellerSelected: any = false;
				if (($('#members-travel--subsidy').length) > 0) {
					$('#members-travel--subsidy input[type=checkbox]').each(function () {
						if ($(this).hasClass('terms_check_gst')) {
							if ($(this).is(":checked") && $(this).parents().eq(5).children().eq(3).find('.traveller-colr').eq(1).text() == 'Adult')  {
								isTravellerSelected = true;
							}
						}

					});
				}
				if(isTravellerSelected) {
					$('.gts-container').css({ 'opacity': '1', 'pointer-events': 'auto' });
				} else {
					$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
				}	
				$('.firsttraveller_'+indexArray2[0]).css('border','1px solid #ccc');
			}

			
		});
		$('.check-box--terms--cond--section').click((evt: any) => {
			if ($('#gst--form--condition').is(":checked") == true) {
				let isTravellerSelected: any = false;
				if (($('#members-travel--subsidy').length) > 0) {
					$('#members-travel--subsidy input[type=checkbox]').each(function () {
						if (!$(this).hasClass('terms_check_gst')) {
							if ($(this).is(":checked") && $(this).parents().eq(5).children().eq(3).find('.traveller-colr').eq(1).text() == 'Adult') {
								isTravellerSelected = true;
							}
						}

					});
				}
				if(isTravellerSelected) {
					$('.gts-container').css({ 'opacity': '1', 'pointer-events': 'auto' });
				} else {
					$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
				}	
				
			} else {
				$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
			}
		});
			
	}
	addmytraveller():any
	{
		let _self = this;
		_self.$scope.find('.btn-memberadd--submit').click((evt: any) => {
		$('#addtraveller-detail').show();
		$('.btn-memberadd--submit').hide();
		$('#addtraveller_mobileadd').hide();
		$(".user--claimed--msg").addClass("hideClass");
		$(".user--claimed--msg").removeClass("showClass");
		$('#member-profile-add input:not([id*="-selectized"],[id*="action"]), selectize, textarea').val('');
		var inputSelectArr = $.makeArray($('#member-profile-add').find('select'));
		$.each(inputSelectArr,function(i:number, el:any){
		el.selectize.clear();
		});
		if (($('#members-travel--subsidy').length) > 0) 
		{
			$('.edittraveller-details').css({ 'pointer-events': 'none' });
			$('.select--checkbox').css({'pointer-events': 'none' });	
			$('.check-box--terms--cond--section').css({ 'pointer-events': 'none' });
		}
		let addmy_showtrar=evt.currentTarget.parentElement.nextElementSibling;
		let addmy_showtraveller=$(addmy_showtrar).nextAll();	
		$(addmy_showtraveller).css({ 'opacity': '0.5','pointer-events': 'none' });
		 $(window).unbind('scroll');
		 evt.preventDefault();
         evt.stopPropagation();
		});

		_self.$scope.find('#addtraveller_mobileadd').click((evt: any) => {
		$('#addtraveller-detail').show();
		$('#addtraveller_mobileadd').hide();
		$('.btn-memberadd--submit').hide();
		$(".user--claimed--msg").addClass("hideClass");
		$(".user--claimed--msg").removeClass("showClass");
		$('#member-profile-add input:not([id*="-selectized"],[id*="action"]), selectize, textarea').val('');
		var inputSelectArr = $.makeArray($('#member-profile-add').find('select'));
		$.each(inputSelectArr,function(i:number, el:any){
		el.selectize.clear();
		});
		if (($('#members-travel--subsidy').length) > 0) 
		{
			$('.edittraveller-details').css({ 'pointer-events': 'none' });
			$('.select--checkbox').css({'pointer-events': 'none' });	
			$('.check-box--terms--cond--section').css({ 'pointer-events': 'none' });
		}
		let addmy_showtravellerq=evt.currentTarget.parentElement.children[4];
		let addmy_showtravellera=$(addmy_showtravellerq).nextAll();
		$(addmy_showtravellera).css({ 'opacity': '0.5','pointer-events': 'none' });
		$(window).unbind('scroll');
		evt.preventDefault();
		evt.stopPropagation();
	});
	}
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr   = $('#add-profile--date-of-birth');
		let inputExpiryArr   = $('#add-profile--passport-expiry-date');
		let inputDateArr1   = $('#firsttraveller_0edit-profile--date-of-birth');
		let inputExpiryArr1   = $('#firsttraveller_0edit-profile--passport-expiry-date');
		let inputDateArr8   = $('#firsttraveller_8edit-profile--date-of-birth');
		let inputExpiryArr8   = $('#firsttraveller_8edit-profile--passport-expiry-date');
		let inputDateArr2   = $('#firsttraveller_2edit-profile--date-of-birth');
		let inputExpiryArr2   = $('#firsttraveller_2edit-profile--passport-expiry-date');
		let inputDateArr3   = $('#firsttraveller_3edit-profile--date-of-birth');
		let inputExpiryArr3   = $('#firsttraveller_3edit-profile--passport-expiry-date');
		let inputDateArr4  = $('#firsttraveller_4edit-profile--date-of-birth');
		let inputExpiryArr4   = $('#firsttraveller_4edit-profile--passport-expiry-date');
		let inputDateArr5  = $('#firsttraveller_5edit-profile--date-of-birth');
		let inputExpiryArr5   = $('#firsttraveller_5edit-profile--passport-expiry-date');
		let inputDateArr6   = $('#firsttraveller_6edit-profile--date-of-birth');
		let inputExpiryArr6   = $('#firsttraveller_6edit-profile--passport-expiry-date');
		let inputDateArr7 = $('#firsttraveller_7edit-profile--date-of-birth');
		let inputExpiryArr7   = $('#firsttraveller_7edit-profile--passport-expiry-date');
		let inputDateArr9 = $('#firsttraveller_1edit-profile--date-of-birth');
		let inputExpiryArr9   = $('#firsttraveller_1edit-profile--passport-expiry-date');

		//let inputElArr:any = $.makeArray(inputDateArr,inputExpiryArr);
		
		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getTime() - 1000*60*60*24*365*2));
		let expiryminDate = 0;
		let $addProfileFlag:any   		= $('#addProfileFlag').val();
		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr, expiryminDate, );
		_self.memberBase.initDatepickerInputs(inputDateArr1, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr1, expiryminDate, );
		_self.memberBase.initDatepickerInputs(inputDateArr2, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr2, expiryminDate, );	
		_self.memberBase.initDatepickerInputs(inputDateArr3, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr3, expiryminDate, );
		_self.memberBase.initDatepickerInputs(inputDateArr4, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr4, expiryminDate, );
		_self.memberBase.initDatepickerInputs(inputDateArr5, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr5, expiryminDate, );	
		_self.memberBase.initDatepickerInputs(inputDateArr6, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr6, expiryminDate, );
		_self.memberBase.initDatepickerInputs(inputDateArr7, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr7, expiryminDate, );
		_self.memberBase.initDatepickerInputs(inputDateArr8, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr8, expiryminDate, );	
		_self.memberBase.initDatepickerInputs(inputDateArr9, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr9, expiryminDate, );	
	}

displymytraller():any 
{
	$('.myModalTraveller').hide();
	$('#showtraveller-details').show();
	$('#showtraveller-details_1').show();
	$('#showtraveller-details_2').show();
	$('#showtraveller-details_3').show();
	$('#showtraveller-details_4').show();
	$('#showtraveller-details_5').show();
	$('#showtraveller-details_6').show();
	$('#showtraveller-details_7').show();
	$('#showtraveller-details_8').show();
	$('#addtraveller-detail').hide();
	$('#updatetraveller-detail').hide();
	$('#updatetraveller-detail_1').hide();
	$('#updatetraveller-detail_2').hide();
	$('#updatetraveller-detail_3').hide();
	$('#updatetraveller-detail_4').hide();
	$('#updatetraveller-detail_5').hide();
	$('#updatetraveller-detail_6').hide();
	$('#updatetraveller-detail_7').hide();
	$('#updatetraveller-detail_8').hide();
	$('#hidetraveller').hide();
	$('#hidetraveller_1').hide();
	$('#hidetraveller_2').hide();
	$('#hidetraveller_3').hide();
	$('#hidetraveller_4').hide();
	$('#hidetraveller_5').hide();
	$('#hidetraveller_6').hide();
	$('#hidetraveller_7').hide();
	$('#hidetraveller_8').hide();
}
populatedataa():any
{	
	let countrycodeurl: string = '';
	var nationalityName = $.Deferred();
	if (window.location.hostname === 'localhost' && window.location.port == '5000') {
		countrycodeurl = '/dummy-data/countrycode.json';
	}
	else {
		countrycodeurl = '/content/dam/mas/json/countrycode.json';
	}
	$.get(countrycodeurl)
		.done((data: any) => {
			var nationalityNameDisp = "";
			if (typeof data === 'string') {
				data = JSON.parse(data);
			}
			nationalityName.resolve(data);

		})
		.fail((error: any) => {
			nationalityName.reject(error);
		});

	$('.file-upload--size--error').addClass("hideClass");
		let formData:Array<any> = [];
		let populateurl:string = '';
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/addtraveller.json';
		}
		else {
			populateurl = '/bin/services/new/getMytravellerAPI';
		}
		let _self = this;
		let bcommon = _self.bookingformcommon;
		bcommon.preloader();
		$.when(nationalityName).done(function (nationalityArray: any) {
		$.ajax({
			type: 'GET',
			url:populateurl,
			success: function(msg:any) {
				if(typeof msg==='string'){
				msg = JSON.parse(msg);
				}else{
					msg=msg;
				}
				$(".tag-lineno").html((msg.travellersDetails.length));
				if (($('#members-travel--subsidy').length)>0)
		 		{
					 if(msg.travellersDetails.length===0)
					 {
						$(".tag-lineno").html("1");
					 }
				}
				$(".mytravellererror_message").html("");
				if(msg != "{}")
				{
					let res =msg;
					let i=0;
					if(msg.travellersDetails.length===8)
					{
					 $('.btn-memberadd--submit').css({ 'opacity': '0.5','pointer-events': 'none' });
					 $('#addtraveller_mobileadd').hide();
					}
					else
					{
					$('.btn-memberadd--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });
					$('#addtraveller_mobileadd').show();
					}
					
					for (i = 0; i < msg.travellersDetails.length; i++) {
						let j:any = 0;
						j =i+1;
						$('.firsttraveller_'+j).show();
						let airlinecode=msg.travellersDetails[i].airlinecode
					   switch(airlinecode)
						{
						case 'AA' :
						$("#traveller-airline_"+j).html('American Airlines');
						break;
						case 'BA':
						$("#traveller-airline_"+j).html('British Airways');
						break;
						case 'KA' :
						$("#traveller-airline_"+j).html('Cathay Dragon');
						break;
						case 'CX' :
						$("#traveller-airline_"+j).html('Cathay Pacific');
						break;
						case 'EK' :
						$("#traveller-airline_"+j).html('Emirates');	
						break;
						case 'EY' :
						$("#traveller-airline_"+j).html('Etihad Airways');	
						break;
						case 'AY' :
						$("#traveller-airline_"+j).html('Finnair');
						break;
						case 'IB' :
						$("#traveller-airline_"+j).html('Iberia');	
						break;
						case 'JL' :
						$("#traveller-airline_"+j).html('Japan Airlines');
						break;
						case 'KL' :
						$("#traveller-airline_"+j).html('KLM Royal Dutch Airlines');
						break;
						case 'LA' :
						$("#traveller-airline_"+j).html('LATAM Airlines Group');
						break;
						case 'MH' :
						$("#traveller-airline_"+j).html('Malaysia Airlines');
						break;
						case 'QF' :
						$("#traveller-airline_"+j).html('Qantas Airways');	
						break;
						case 'QR' :
						$("#traveller-airline_"+j).html('Qatar Airways');
						break;
						case 'RJ' :
						$("#traveller-airline_"+j).html('Royal Jordanian');
						break;
						case 'S7' :
						$("#traveller-airline_"+j).html('Siberia Airlines');
						break;
						case 'SQ' :
						$("#traveller-airline_"+j).html('Singapore Airlines');
						break;
						case 'UL' :
						$("#traveller-airline_"+j).html('SriLankan Airlines');
						break;
						
						}
					$("#traveller-title_"+j).html(msg.travellersDetails[i].title);
					$("#traveller-name_"+j).html((msg.travellersDetails[i].givenName)+'&nbsp'+(msg.travellersDetails[i].lastname));
					$("#traveller-dob_"+j).html(msg.travellersDetails[i].dob);
		if (($('#members-travel--subsidy').length)>0)
		 {
			//  $('.mobile-nav .mobile-enrich-login').addClass('hide')
			//  $('.mobile .enrich-login').addClass('hide');
			 $(".firsttraveller_"+j+" .circle-travel").html(j+1)
			 $(".tag-lineno").html((msg.travellersDetails.length)+1)
			 $("#traveller-nric-num_"+j).html(msg.travellersDetails[i].nric);
					if(msg.travellersDetails[i].hasPhoto=="Y")
					{
						$("#traveller-ic-attachment_"+j).addClass("showClass");
					    $("#traveller-ic-attachment_"+j).removeClass("hideClass");
					}else{
						$("#traveller-ic-attachment_"+j).removeClass("showClass");
						$("#traveller-ic-attachment_"+j).addClass("hideClass");
					}
					if(msg.travellersDetails[i].nationality=="MY" || msg.travellersDetails[i].nationality=="Malaysia" ||msg.travellersDetails[i].nationality=="MALAYSIA")
					{
						$("#traveller-nationality--error--info_"+j).addClass("hideClass");
						$("#traveller-nationality--error--info_"+j).removeClass("showClass");
						$('.firsttraveller_'+j).css('border','1px solid #ccc');
						$('#traveller-check_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
						$('#traveller-check_'+j).show();
						if(msg.travellersDetails[i].nric!='')
						{
							
							$("#traveller-nric--details--info_"+j).addClass("hideClass");
							$("#traveller-nric--details--info_"+j).removeClass("showClass");
							$('.firsttraveller_'+j).css('border','1px solid #ccc');
							$('#traveller-check_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
							$('#traveller-check_'+j).show();
							if(msg.travellersDetails[i].hasPhoto=="Y")
								{
								}else{
									$("#traveller-nric--details--info_"+j).addClass("showClass");
									$("#traveller-nric--details--info_"+j).removeClass("hideClass");
									$('.firsttraveller_'+j).css('border','2px solid red');
									//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
									$('#traveller-check_'+j).hide();
								}
							
						}else{
							$('.firsttraveller_'+j).css('border','2px solid red');
							$("#traveller-nric--details--info_"+j).addClass("showClass");
							$("#traveller-nric--details--info_"+j).removeClass("hideClass");
							//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
							$('#traveller-check_'+j).hide();
						}
					}else{
						//alert("Nationality>>1"+msg.travellersDetails[i].nationality);
						$("#traveller-nationality--error--info_"+j).addClass("showClass");
						$("#traveller-nationality--error--info_"+j).removeClass("hideClass");
						$('.firsttraveller_'+j).css('border','2px solid red');
						//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
						$('#traveller-check_'+j).hide();
					}
					if(msg.travellersDetails[i].isused=="Y")
					$("#traveller-nric-num_"+j).html(msg.travellersDetails[i].nric);
					if(($('#members-travel--subsidy').length)>0)
					{
						if(msg.travellersDetails[i].nationality=="MY" || msg.travellersDetails[i].nationality=="Malaysia" || msg.travellersDetails[i].nationality=="MALAYSIA")
						{
							$("#traveller-nationality--error--info_"+j).addClass("hideClass");
							$("#traveller-nationality--error--info_"+j).removeClass("showClass");
							$('.firsttraveller_'+j).css('border','1px solid #ccc');
							$('#traveller-check_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
							$('#traveller-check_'+j).show();
							if(msg.travellersDetails[i].nric!='')
							{
								$("#traveller-nric--details--info_"+j).addClass("hideClass");
								$("#traveller-nric--details--info_"+j).removeClass("showClass");
								$('.firsttraveller_'+j).css('border','1px solid #ccc');
								$('#traveller-check_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
								$('#traveller-check_'+j).show();
								if(msg.travellersDetails[i].hasPhoto=="Y")
								{
								}else{
									$("#traveller-nric--details--info_"+j).addClass("showClass");
								    $("#traveller-nric--details--info_"+j).removeClass("hideClass");
									$('.firsttraveller_'+j).css('border','2px solid red');
									//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
									$('#traveller-check_'+j).hide();
								}
								
							}else{
								
								$('.firsttraveller_'+j).css('border','2px solid red');
								$("#traveller-nric--details--info_"+j).addClass("showClass");
								$("#traveller-nric--details--info_"+j).removeClass("hideClass");
								//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
								$('#traveller-check_'+j).hide();
							}
					    }else{
							//alert("Nationality>>2"+msg.travellersDetails[i].nationality);
							$("#traveller-nationality--error--info_"+j).addClass("showClass");
							$("#traveller-nationality--error--info_"+j).removeClass("hideClass");
							$('.firsttraveller_'+j).css('border','2px solid red');
							//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
							$('#traveller-check_'+j).hide();
						}
						if(msg.travellersDetails[i].isused=="Y")
						{
							//alert("isused11==Y");
							$("#traveller-nationality--error--info_"+j).addClass("hideClass");
							$("#traveller-nationality--error--info_"+j).removeClass("showClass");
							$("#traveller-nric--details--info_"+j).addClass("hideClass");
							$("#traveller-nric--details--info_"+j).removeClass("showClass");
							$('.firsttraveller_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
							$('#traveller-check_'+j).hide();
							$('.firsttraveller_'+j).css('border','1px solid #ccc');
							$("#traveller-gts--used--info_"+j).addClass("showClass");
							$("#traveller-gts--used--info_"+j).removeClass("hideClass");
							$('.firsttraveller_'+j+' .deletetraveller-details').css({ 'pointer-events': 'auto'});
							$('.firsttraveller_'+j+' .edittraveller-details' ).addClass("data-offer");
						}else{
							$('.firsttraveller_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
							//$('.firsttraveller_'+j).css({ 'opacity': '1.0','pointer-events': 'none', 'background': '#cccccc' });
							//$('.firsttraveller_'+j+' .edittraveller-details' ).addClass("data-offer");
							$("#traveller-gts--used--info_"+j).addClass("hideClass");
							$("#traveller-gts--used--info_"+j).removeClass("showClass");
							//$('#traveller-check_'+j).show();
							//$('.firsttraveller_'+j+' .edittraveller-details .fa.fa-edit').hide();
							//$('.firsttraveller_'+j+' .deletetraveller-details').css({ 'pointer-events': 'auto'});
						}
					}	

		 }
		else
		{
			$('.firsttraveller_0').hide();
			$('.nric-information').hide();
			$('.check-box--section').hide();
		}
					const age = moment().diff(msg.travellersDetails[i].dob, 'years');
					if(age>=12){
						$("#traveller-type_"+j).html("Adult");
					}		
					else
					{
						$("#traveller-type_"+j).html("Child");
					}
					$("#traveller-passportno_"+j).html(msg.travellersDetails[i].passportnumber);
					$("#traveller-expirydate_"+j).html(msg.travellersDetails[i].expirydate);
					var nationalityCode = msg.travellersDetails[i].nationality;
					var passportIssueCnty = msg.travellersDetails[i].passportissuingcountry;
						for (var k = 0; k < nationalityArray.Countries.length; k++) {
							if (nationalityArray.Countries[k].Code == nationalityCode) {
								
								$("#traveller-nationality_"+j).html(nationalityArray.Countries[k].Name);
							} 
							if (nationalityArray.Countries[k].Code == passportIssueCnty) {
								
								$("#traveller-issuingcountry_"+j).html(nationalityArray.Countries[k].Name);

							} 
						}
					$("#traveller-airlineno_"+j).html(msg.travellersDetails[i].airlinenumber);
					$("#index_"+(j+1)).val(msg.travellersDetails[i].index);			
					$("#firsttraveller_"+j+"--select").val(msg.travellersDetails[i].index);
				}

				for (i =(msg.travellersDetails.length+1); i<9; i++) 
				{
					$('.firsttraveller_'+i).hide();
				}
				
				}
			bcommon.preloaderClose();
			},
			error: function(error:any) 
			{
			$('#member-myadd-traveller').hide();
			$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
			$('html, body').animate({ scrollTop: '100px' });
			bcommon.preloaderClose();
			}
			
			});
				
		});
}
removetraveller():any{

		let _self = this;
		$('.btn-mytraveler--remove').click((evt: any) => {	
		let indexedit:any = $("#deleteBox").val();	
		indexedit = indexedit.split('x')[1]-1;
		let i:any = $("#index_"+indexedit).val();
		$.magnificPopup.close();
		 $(window).unbind('scroll');
		 evt.preventDefault();
         evt.stopPropagation();
	
			let data:any = {
				'action' : 'delete',
				'index' : i
				}
			$.ajax({
					type: 'POST',
					data:data,
					url: '/bin/services/new/myTravellerDetailsAPI',
					success: function(msg:any) {
					if(typeof msg==='string'){
					msg = JSON.parse(msg);
					}else{
						msg=msg;
					}
					$(".mytravellererror_message").html("");
					_self.populatedataa();			
					},
					error: function(error:any) {
					$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
					$('html, body').animate({ scrollTop: '100px' });
					}
				});

 	});
}
gov_subsidy():any
{
	let _self = this;
	var data = {
		'action': 'fetch'
	};
	let method:any = 'POST';
   	if (($('#members-travel--subsidy').length)>0)
		 {
			 //$(".tagline").text('You can add up to 9 travellers');
			if($(".gov-wrapper #member-myadd-traveller")){
				$("input[id^='firsttraveller_0edit-']").prop('readonly', true);
				// $("input[id^='firsttraveller_0add-user--NRIC--number']").prop('readonly', true);
				$('.firsttraveller_0edit-profile--date-of-birth').datepicker('disable');
		}
		$('#member-myadd-traveller h1').remove();
		$('#members-travel--subsidy .tag-line-total').html('/9');
		let	populateurl
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/gst_traveller.json';
			method = 'GET';
		}
		else {
			populateurl = '/bin/services/new/updateuser';
			method = 'POST';
		}
		let _self = this;
		let bcommon = _self.bookingformcommon;
		$.ajax({
			type: method,
			data:data,
			url:populateurl,
			success: function(msg:any) {
				if(typeof msg==='string'){
				msg = JSON.parse(msg);
				}else{
					msg=msg;
				}

				if(msg != "{}")
				{
					const age = moment().diff(msg.dob, 'years');
					if(age<12){
					$.magnificPopup.open({
							items: {
								src: '#gts-restrict-child'
							},
							type: 'inline',
							//alignTop: true,
							midClick: true,
							mainClass: 'mfp-fade',
							closeOnBgClick: false,
							enableEscapeKey: false,
							showCloseBtn: false
						});
					}
					else {

					if($(".tag-lineno").text()==="0")
					{
						$(".tag-lineno").html("1");
					}
					
					$("#traveller-title_0").html(msg.title);
					$("#traveller-name_0").html((msg.firstName)+'&nbsp'+(msg.lastName));
					$("#traveller-dob_0").html(msg.dob);
					$("#traveller-nric-num_0").html(msg.nricnumber);
					$("#emailmember").val(msg.email);
					$("#email_1").val(msg.email);
					if(msg.nationality=="MY" || msg.nationality=="Malaysia" || msg.nationality=="MALAYSIA")
					{
						$("#traveller-nationality--error--info_0").addClass("hideClass");
						$("#traveller-nationality--error--info_0").removeClass("showClass");
						$(".firsttraveller_0").css('border','1px solid #ccc');
						//$("#traveller-check_0").css({ 'opacity': '1.0','pointer-events': 'auto' });
						$('#traveller-check_0').show();
					}else{
						$("#traveller-nationality--error--info_0").addClass("showClass");
						$("#traveller-nationality--error--info_0").removeClass("hideClass");
						$(".firsttraveller_0").css('border','2px solid red');
						$('#traveller-check_0').hide();
					}
					let hasPhoto:any;
					let isUsed:any;
					let memberEmal:any = $("#emailmember").val();
					//alert("memberEmal>>"+msg.email+"memberEmal>>"+memberEmal+"msg.isUsed>>"+msg.isUsed);
							$.ajax({
								type: 'GET',
								url:'/bin/services/new/gtsRegistration?icnumber='+msg.nricnumber+'&email='+msg.email,
								success: function(response:any) {
										   if(typeof response==='string'){
											response = JSON.parse(response);
											}else{
												response=response;
											}
											if(response != "{}")
											{
												hasPhoto=response.hasPhoto;
												isUsed=response.isUsed;
												//alert("hasPhoto>>"+hasPhoto+"isUsed>>"+isUsed);
												if(hasPhoto=="Y")
												{
													$("#traveller-ic-attachment_0").addClass("showClass");
													$("#traveller-ic-attachment_0").removeClass("hideClass");
												}else{
													$("#traveller-ic-attachment_0").removeClass("showClass");
													$("#traveller-ic-attachment_0").addClass("hideClass");
												}
												if(msg.nationality=="MY" || msg.nationality=="Malaysia" || msg.nationality=="MALAYSIA")
													{
														$("#traveller-nationality--error--info_0").addClass("hideClass");
														$("#traveller-nationality--error--info_0").removeClass("showClass");
														$(".firsttraveller_0").css('border','1px solid #ccc');
														//$("#traveller-check_0").css({ 'opacity': '1.0','pointer-events': 'auto' });
														$('#traveller-check_0').show();
														if(msg.nricnumber!="")
														{
															$("#traveller-nric--details--info_0").addClass("hideClass");
															$("#traveller-nric--details--info_0").removeClass("showClass");
															$(".firsttraveller_0").css('border','1px solid #ccc');
															//$("#traveller-check_0").css({ 'opacity': '1.0','pointer-events': 'auto' });
															$('#traveller-check_0').show();
															if(hasPhoto=="Y")
															{
															
															}else{
															$(".firsttraveller_0").css('border','2px solid red');
															//$("#traveller-check_0").css({ 'opacity': '0.5','pointer-events': 'none' });
															$('#traveller-check_0').hide();
															$("#traveller-nric--details--info_0").addClass("showClass");
															$("#traveller-nric--details--info_0").removeClass("hideClass");
															}
														}else{
															$(".firsttraveller_0").css('border','2px solid red');
															$("#traveller-nric--details--info_0").addClass("showClass");
															$("#traveller-nric--details--info_0").removeClass("hideClass");
															//$("#traveller-check_0").css({ 'opacity': '0.5','pointer-events': 'none' });
															$('#traveller-check_0').hide();
														}
														}else{
														$("#traveller-nationality--error--info_0").addClass("showClass");
														$("#traveller-nationality--error--info_0").removeClass("hideClass");
														$(".firsttraveller_0").css('border','2px solid red');
														//$("#traveller-check_0").css({ 'opacity': '0.5','pointer-events': 'none' });
														$('#traveller-check_0').hide();
														}
														if(isUsed=="Y")
														{
															//alert("isused1member==Y");
														$('.firsttraveller_0').css({ 'opacity': '0.5','pointer-events': 'none' });
														$('#traveller-check_0').hide();
														$(".firsttraveller_0").css('border','1px solid #ccc');
														//$('.firsttraveller_0 .edittraveller-details .fa .fa-edit').hide();
														$("#traveller-gts--used--info_0").addClass("showClass");
														$("#traveller-gts--used--info_0").removeClass("hideClass");
														//$('.firsttraveller_0 .deletetraveller-details').css({ 'pointer-events': 'auto'});
														$("#traveller-nric--details--info_0").addClass("hideClass");
														$("#traveller-nric--details--info_0").removeClass("showClass");
														$("#traveller-nationality--error--info_0").addClass("hideClass");
														$("#traveller-nationality--error--info_0").removeClass("showClass");
														//$("#traveller-check_0").css({ 'opacity': '0.5','pointer-events': 'none' });
													}else{
														$(".firsttraveller_0").css({ 'opacity': '1.0','pointer-events': 'auto' });
														$("#traveller-gts--used--info_0").addClass("hideClass");
														$("#traveller-gts--used--info_0").removeClass("showClass");
														//$('#traveller-check_0').show();
													}
											}
											
								}, 
								error: function(error:any) {
									$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
									$('html, body').animate({ scrollTop: '100px' });
								},
							cache: false,
							contentType: false,
							processData: false,
							});					
						
					
					const age = moment().diff(msg.dob, 'years');
					if(age>=12){
						$("#traveller-type_0").html("Adult");
					}		
					else
					{
						$("#traveller-type_0").html("Child");
						
					}

					$("#index_0").val(msg.index);
					$("#firsttraveller_0--select").val(1);
				
				}
			}
			},
			error: function(error:any) 
			{

			}
			
			});
		}
	else
		{
			$('.firsttraveller_0').hide();
			$('.nric-information').hide();
			$('.check-box--section').hide();
		}
}
fileupload():any{
	let defer = $.Deferred();
	let _self = this;
	//let redeemBal = _self.travellerForm.find( '#nric-files-upload');
	//let icNum = _self.travellerForm.find( '#nric--upload--file--name');
	$("#add-user--NRIC--number").keypress(function (e:any) {
		if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
			//display error message
			//$(".cardnumberformatErrMsg").show();
			return false;
		}
		else {
			//$(".cardnumberformatErrMsg").remove();
			return true;
		}
	});
	
	for(let i=0;i<=8;i++){
		$("#firsttraveller_"+i+"add-user--NRIC--number").keypress(function (e:any) {
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				return false;
			}
			else {
				return true;
			}
		});
	}
	var fileExtension = ["jpg", "jpeg", "tiff", "png", "gif","doc","pdf"];
	let formUploadValidFileCount:any = 0;
	
	$(document.body).on('change', '.nric-files-upload' ,function() {

		/*let dob = _self.travellerForm.find( '#add-profile--date-of-birth').val();
		let icNum = _self.travellerForm.find( '#add-user--NRIC--number').val();
		let myDate = new Date(dob);
		let d = myDate.getDate()+'';
		let m =  myDate.getMonth();
		m += 1;  // JavaScript months are 0-11
		let y = myDate.getFullYear()+'';
		let dob_val=d+m+y;
		let icNum_val = icNum.substring(0, 8);
		if(icNum_val==dob_val){
			alert("true");
		}else{
			alert("false");
			_self.travellerForm.find( '#add-user--NRIC--number').val('');
		}*/



		//_self.$scope.find('.nric-files-upload').click((evt: any) => {
			 let icNameAttr:any;
			//editTraveller = evt.currentTarget.parentElement.className;
		//alert("editTraveller>>"+editTraveller);
		var fsize = $(this)[0].files.item(0).size;
		//alert("fsize>>"+fsize);
		//icNum.val($(this)[0].files.item(0).name);
		let name=$(this)[0].files.item(0).name;
		//alert("name>>"+name);
		let className=$(this)[0].className;
		//alert("className>>"+className);
		//let classNameLen=$(this)[0].parentElement.className;
		//alert("className>>"+classNameLen);
		let getattr=$(this)[0].getAttribute('name');
		//alert("getattr>>"+getattr);
		//getattr=getattr.split("---")
		//alert("classNameLen>>"+getattr.length);
		//if(getattr.length==2){
		//let	attr=getattr[0];
		//alert("attr>>"+attr);
		//icNameAttr=_self.travellerForm.find('#'+attr+'nric--upload--file--name');
		//}else{
			icNameAttr=_self.travellerForm.find( '.nric--upload--file--name');
		//}
		icNameAttr.val($(this)[0].files.item(0).name);

		if ((fileExtension.indexOf($(this)[0].files.item(0).name.split('.').pop().toLowerCase()) < 0)) {
			$(this).addClass('error-validation');
			formUploadValidFileCount=0;
			//$('.file-upload--image--error').show();
			$('.file-upload--image--error').addClass("showClass");
			$('.file-upload--image--error').removeClass("hideClass");
			icNameAttr.val('');
			$('.nric-files-upload').val('');
			
		} else {
			$(this).removeClass('error-validation');
			formUploadValidFileCount=1;
			//$('.file-upload--image--error').hide();
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
		}

		if ((parseFloat((fsize / (1024*1024)).toFixed(2)) >= 5)) {
			$(this).addClass('error-validation');
			$('.file-upload--size--error').addClass("showClass");
			$('.file-upload--size--error').removeClass("hideClass");
			icNameAttr.val('');
			$('.nric-files-upload').val('');
		} else {
			$(this).removeClass('error-validation');
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
		}
	});
}

	hideTravellers(): any {
		if (($('#members-travel--subsidy').length) > 0) {
			$('.addmytraveller').hide();
			$('.btn-memberadd--submit').hide();
			$('.firsttraveller_0').parent().nextAll().addClass('hide');

		}
	}
}
let scope:Element = document.querySelector('#member-myadd-traveller');

if (scope) {
	try {
    let addtraveller = new memberAddTraveller();
	addtraveller.displymytraller();
	addtraveller.mytraveller();
	addtraveller.initSelectizeInputs();
	addtraveller.editmytraveller();
	addtraveller.addmytraveller();
	addtraveller.cancelmytraveller();
	addtraveller.deletemytraveller();
	addtraveller.selectTraveller();
	addtraveller.removetraveller();
	addtraveller.canceldeletemytraveller();
	addtraveller.initDatepickerInputs();
	addtraveller.gov_subsidy();
	addtraveller.populatedataa();
	addtraveller.initTextInputs();
	addtraveller.fileupload();
	//addtraveller.hideTravellers();
	} catch(e) {console.error(e);}
}